/* eslint-disable react/no-danger */
import React from 'react'
import { shape, string } from 'prop-types'

const LinkPromotion = ({
  link,
  iconClass,
  linkText,
  customImage,
  trackingCode,
}) => (
  <a
    className="link-promotion globalLink"
    href={link.path}
    data-trackingcode={trackingCode}
  >
    {iconClass ? <i className={iconClass} /> : null}
    {!iconClass && customImage ? <img alt="" src={customImage} /> : null}
    <span
      className="promo-link"
      dangerouslySetInnerHTML={{ __html: linkText }}
    />
  </a>
)

LinkPromotion.propTypes = {
  link: shape({
    path: string,
  }),
  linkText: string.isRequired,
  iconClass: string,
  trackingCode: string,
  customImage: string,
}

LinkPromotion.defaultProps = {
  link: {
    path: '',
  },
  iconClass: '',
  trackingCode: '',
  customImage: '',
}

export default LinkPromotion



// WEBPACK FOOTER //
// ./components/link-promotions/LinkPromotion.js